<template>
  <div class="container-fluid">
    <div class="row" v-if="!hasResumeCdcError">
      <div class="col-md-4">
        <pre-approve-model-risk-form
          ref="riskModelForm"
          :project-id="projectId"
          @onLoaded="isFormLoaded = true"
          @hasError="errorHandler"
          :schema.sync="schemaResponse"/>
      </div>
      <div class="col-md-8">
        <template v-if="responseModel">
          <!-- Printing Result Card-->
          <div class="vx-row">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
              <risk-model-result
                :score="parseFloat(responseModel.score)"
                :high-config="[79, 100]"
                :medium-config="[64, 78]"
                :low-config="[0, 63]"
                :show-qualification="false" />
            </div>
          </div>

          <!-- Printing Result Table -->
          <vs-table stripe :data="responseModel.results.groups">
            <template slot="thead" class="thead-dark">
              <vs-th>Regla</vs-th>
              <vs-th>Peso de la categoría</vs-th>
              <vs-th>Resultado</vs-th>
              <vs-th>Porcentaje</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr
                v-for="(group, index) in data"
                :key="index"
                v-bind:class="{'text-danger': group.result <= 50}"
                v-if="group.rules.length > 0">
                <vs-td><strong>{{ group.name }}</strong></vs-td>
                <vs-td>{{ group.weight|fixNumber }}%</vs-td>
                <vs-td>{{ group.result|fixNumber }} %</vs-td>
                <vs-td>{{ group.score|fixNumber }}</vs-td>

                <template slot="expand">
                  <div class="con-expand-users w-full">
                    <vs-table :data="group.rules">
                      <template slot="thead">
                        <vs-th>Indicadores</vs-th>
                        <vs-th>Peso indicador</vs-th>
                        <vs-th>Puntaje indicador</vs-th>
                        <vs-th>Calificación indicador</vs-th>
                        <vs-th>Respuesta</vs-th>
                        <vs-th>Limite inferior</vs-th>
                        <vs-th>Limite superior</vs-th>
                        <vs-th>Tipo de análisis</vs-th>
                      </template>
                      <template slot-scope="{data}">
                        <vs-tr
                          v-for="rule in data"
                          :key="`trx-${rule.identity_name}`"
                          v-bind:class="{'text-danger': rule.score <= 50}">
                          <vs-td><strong>{{ rule.name }}</strong></vs-td>
                          <vs-td>{{ rule.weight|fixNumber }}%</vs-td>
                          <vs-td>{{ rule.result|fixNumber }}</vs-td>
                          <vs-td>{{ rule.score|fixNumber }}%</vs-td>
                          <vs-td>{{ rule.answer|fixIfIsFloat}}</vs-td>
                          <vs-td>{{ rule.worst_value }}</vs-td>
                          <vs-td>{{ rule.best_value }}</vs-td>
                          <vs-td>{{ rule.analysis_type.type }}</vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </template>
              </vs-tr>
            </template>

          </vs-table>

        </template>

        <vs-button
          :disabled="this.$refs.riskModelForm && this.$refs.riskModelForm.formError !== ''"
          class="mt-5" @click="runPreApproveModel()">
          Modelo de Pre aprobación
        </vs-button>
      </div>
    </div>
    <div v-else>
      <span v-if="isFormLoaded">
        <vs-alert color="warning">
          Para ejecutar el modelo de Pre Aprobación es necesario ejecutar el reporte de Cdc.
        </vs-alert>
      </span>
    </div>
  </div>
</template>

<script>
import PreApproveModelRiskForm from "@views/admin/RiskModel/Dashboard/RiskModel/PreApproveForm/PreApproveModelRiskForm";
import RiskModelResult from "@views/admin/RiskModel/Dashboard/RiskModel/Components/RiskModelResult";
import {fixNumber} from "@/filters/NumberFilters";
import {mapState} from "vuex";

export default {
  name: "PreApproveRiskModelV2",
  components: {RiskModelResult, PreApproveModelRiskForm},
  data: () => ({
    projectId: null,
    formError: "",
    schemaResponse: {},
    responseModel: null,
    isFormLoaded: false,
    hasResumeCdcError: false
  }),
  computed: {
    ...mapState("projects", ["project"])
  },
  filters: {
    fixNumber,
    fixIfIsFloat(val) {
      if(typeof val == 'number' && !isNaN(val)) {
        if (!Number.isInteger(val)) {
          return val.toFixed(4)
        }
      }
      return val;
    }
  },
  async mounted() {
    await this.main();
  },
  methods: {
    async main() {
      try {
        const { data }  = await axios.post(`/api/risk-model/pre-approve`, {
          projectId: this.$route.params.id,
          fiscalProfileId: this.project.client.fiscal.id,
          type: this.project.client.fiscal.fiscal_type
        })

        this.responseModel = data.current;

        this.$emit("onLoaded", data)
      } catch (e) {
        this.formError = e.response.data.error;
      }
    },
    renderForm() {
      this.$refs.riskModelForm.main()
    },
    async runPreApproveModel() {
      this.$vs.loading();
      try {
        const { data } = await axios.post(`/api/risk-model/pre-approve/run`, {
          projectId: this.$route.params.id,
          versionId: "Modelo 3.2",
          personType: this.project.client.fiscal.fiscal_type
        })

        this.responseModel = data;
        this.$vs.loading.close();
        this.$emit("onUpdate", this.responseModel)
      } catch (e) {
        if(e.response.status === 400 && e.response.data.error_type === "resume_cdc") {
          this.hasResumeCdcError = true
        }
        this.$vs.loading.close();
      }
    },
    errorHandler(ev) {
      this.isFormLoaded = true
      if(ev.error_type === "resume_cdc") {
        this.hasResumeCdcError = true
      }
    }
  }
}
</script>

<style scoped>

</style>
